import React from 'react';
import { mergeProps } from 'next-merge-props';

import { getServerSideBlogProps } from '../../modules/blog/getServerSideBlogProps';
import { getServerSideCookieProps } from '../../modules/cookies/getServerSideCookieProps';

import { PageProps } from '../../context/PageData';

import { BlogPost } from '../../components/BlogPost';

export default function DynamicBlogPage(data: PageProps) {
  return <BlogPost {...data} />;
}

export const getServerSideProps = mergeProps([
  getServerSideBlogProps,
  getServerSideCookieProps
]);
